export const isUserAdmin = ($userStore) => $userStore && $userStore.role === 'admin'

// List of Keys across all types that use this component that are visible to only admins
export const showInfo = ({ key, isAdmin, adminKeys = [] }) => isAdmin ? true : !adminKeys.includes(key)

export const getName = (store, id) => {
  const item = store.find(item => item._id === id)
  return item ? item.name : 'Unassigned'
}

export const multiFilter = (data = [], filterKeys = [], value = '') => data.filter((item) => filterKeys.some(key => item[key] && item[key].toString().toLowerCase().includes(value.toLowerCase()) && item[key]))

export const stripe = Stripe('pk_live_51HioV1HdsoZxePINlmGxiomfHj2b9okUYfhdylCgZrUBNxwPOq8bGdxsG1GyJZDNzWhhTgWtbbSJk6kNC5I2vzdO00pkxRbGRR')
